import { IconProps } from "../../utils/global-types/global-types";

const ContactsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M6.75 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.75 9a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM6.75 10.5c-2.505 0-4.5 1.245-4.5 3 0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5 0-1.755-1.995-3-4.5-3ZM12.75 10.5c-.39 0-.795.045-1.185.12.87.69 1.435 1.62 1.435 2.88 0 .825-.675 1.5-1.5 1.5h3.75c.825 0 1.5-.675 1.5-1.5 0-1.755-1.995-3-4-3Z"
      />
    </svg>
  );
};

export default ContactsIcon;
